import ResultsBadges from './ResultsBadges';

export default ResultsBadges;
